import { render, staticRenderFns } from "./RmaShareUpload.vue?vue&type=template&id=497ec354&scoped=true"
import script from "./RmaShareUpload.vue?vue&type=script&lang=js"
export * from "./RmaShareUpload.vue?vue&type=script&lang=js"
import style0 from "./RmaShareUpload.vue?vue&type=style&index=0&id=497ec354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ec354",
  null
  
)

export default component.exports